/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum VerizonTollFreeType {
    Basic = 'BAS',
    Enhanced = 'TVL',
}